// Styles for Tabs go here.
import { baseVariables, toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';

const borderRadius = toRem(40);

export const StyledTabbedWrapper = styled.div`
  position: relative;
  grid-area: 1 / 1;
  z-index: 2;
  margin-left: auto;
  margin-right: auto;
  margin-top: ${toRem(100)};
  @media ${baseVariables.mediaQuery.md} {
    margin-top: ${toRem(136)};
  }
  @media ${baseVariables.mediaQuery.lg} {
    margin-top: ${toRem(152)};
  }
  .tab-banner-title {
    color: ${baseVariables.color['base20']};
    text-align: center;
    margin-bottom: ${toRem(0)};
    padding-bottom: ${toRem(160)};
    font-weight: ${baseVariables.font.fontWeightMedium};
    @media ${baseVariables.mediaQuery.md} {
      padding-bottom: ${toRem(188)};
    }
    @media ${baseVariables.mediaQuery.lg} {
      padding-bottom: ${toRem(212)};
    }
  }

  .tab-arrow {
    position: absolute;
    z-index: 2;
    cursor: pointer;
    height: 40px;
    width: 40px;
    border-radius: 50%;
    align-items: center;
    display: flex;
    justify-content: center;
  }
  .tab-arrow.left {
    left: 14px;
    margin-top: 4px;
    @media ${baseVariables.mediaQuery.sm} {
      left: 0;
    }
  }
  .tab-arrow.right {
    right: 14px;
    margin-top: 4px;
    @media ${baseVariables.mediaQuery.sm} {
      right: 0;
    }
  }
  &.show-left-arrow .tab-navigation .tab-arrow.left,
  &.show-right-arrow .tab-navigation .tab-arrow.right {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .icon-arrow-right,
  .icon-arrow-left {
    font-size: ${toRem(24)};
    color: #ffffff;
  }
  *:has(> &.tabs-wrapper) {
    backdrop-filter: blur(4px);
  }
`;

export const StyledTabNavigation = styled.div`
  padding: ${toRem(4)};
  margin: 0;
  list-style: none;
  display: flex;
  flex-direction: row;
  gap: ${toRem(8)};
  align-items: center;
  justify-content: space-between;
  border-radius: ${borderRadius};
  backdrop-filter: blur(4px);
  background-color: rgba(0, 0, 0, 0.54);
  &.tab-gradient-left {
    -webkit-mask-image: linear-gradient(
      to left,
      rgb(255, 255, 255) 0%,
      rgb(255, 255, 255) 78%,
      rgb(110, 110, 110) 83%,
      transparent 95%
    );
    mask-image: linear-gradient(
      to left,
      rgb(255, 255, 255) 0%,
      rgb(255, 255, 255) 78%,
      rgb(110, 110, 110) 83%,
      transparent 95%
    );
    @media ${baseVariables.mediaQuery.md} {
      -webkit-mask-image: linear-gradient(
        to left,
        rgb(255, 255, 255) 0%,
        rgb(255, 255, 255) 78%,
        rgb(110, 110, 110) 88%,
        transparent 96%
      );
      mask-image: linear-gradient(
        to left,
        rgb(255, 255, 255) 0%,
        rgb(255, 255, 255) 78%,
        rgb(110, 110, 110) 88%,
        transparent 96%
      );
    }
  }
  &.tab-gradient-right {
    -webkit-mask-image: linear-gradient(
      to right,
      rgb(255, 255, 255) 0%,
      rgb(255, 255, 255) 78%,
      rgb(110, 110, 110) 83%,
      transparent 95%
    );
    mask-image: linear-gradient(
      to right,
      rgb(255, 255, 255) 0%,
      rgb(255, 255, 255) 78%,
      rgb(110, 110, 110) 83%,
      transparent 95%
    );

    @media ${baseVariables.mediaQuery.md} {
      -webkit-mask-image: linear-gradient(
        to right,
        rgb(255, 255, 255) 0%,
        rgb(255, 255, 255) 78%,
        rgb(110, 110, 110) 88%,
        transparent 96%
      );
      mask-image: linear-gradient(
        to right,
        rgb(255, 255, 255) 0%,
        rgb(255, 255, 255) 78%,
        rgb(110, 110, 110) 88%,
        transparent 96%
      );
    }
  }
  &.tab-gradient-dual {
    -webkit-mask-image: linear-gradient(
      90deg,
      transparent 5%,
      rgb(255, 255, 255) 17%,
      rgb(255, 255, 255) 22%,
      rgb(255, 255, 255) 78%,
      rgb(110, 110, 110) 83%,
      transparent 95%
    );
    mask-image: linear-gradient(
      90deg,
      transparent 5%,
      rgb(255, 255, 255) 17%,
      rgb(255, 255, 255) 22%,
      rgb(255, 255, 255) 78%,
      rgb(255, 255, 255) 83%,
      transparent 95%
    );
    @media ${baseVariables.mediaQuery.md} {
      -webkit-mask-image: linear-gradient(
        90deg,
        transparent 4%,
        rgb(110, 110, 110) 12%,
        rgb(255, 255, 255) 22%,
        rgb(255, 255, 255) 78%,
        rgb(110, 110, 110) 88%,
        transparent 96%
      );
      mask-image: linear-gradient(
        90deg,
        transparent 4%,
        rgb(110, 110, 110) 12%,
        rgb(255, 255, 255) 22%,
        rgb(255, 255, 255) 78%,
        rgb(110, 110, 110) 88%,
        transparent 96%
      );
    }
  }
  overflow-x: auto;
  scrollbar-width: none;
  scroll-behavior: smooth;
  white-space: nowrap;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
  .tab-item {
    flex: 1 1 0;
    text-align: center;
    cursor: pointer;
    color: ${baseVariables.color['base20']};
    border-radius: ${borderRadius};
    line-height: ${toRem(20)};
    justify-content: center;
    padding: ${toRem(9)} ${toRem(18)};
    @media ${baseVariables.mediaQuery.lg} {
      padding: ${toRem(12)} ${toRem(20)};
    }
    &:hover {
      background-color: ${baseVariables.color['neutral40']};
      color: ${baseVariables.color['base20']};
    }
    &:focus {
      .tab-item {
        outline: 2px solid -webkit-focus-ring-color;
      }
    }

    &.is-active {
      background-color: ${baseVariables.color['base20']};
      color: ${baseVariables.color['base10']};
      .icon-m {
        color: ${baseVariables.color['accent10']};
      }
    }
  }
`;

export const StyledTabBanner = styled.div<{ $theme: string }>`
  position: relative;
  aspect-ratio: 2 / 3;
  grid-area: 1 / 1;
  overflow: hidden;
  @media ${baseVariables.mediaQuery.md} {
    aspect-ratio: 3 / 2;
  }
  @media ${baseVariables.mediaQuery.lg} {
    aspect-ratio: 2 / 1;
  }

  picture {
    display: block;
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  // Gradient for the top of the banner
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.54) 0%, rgba(0, 0, 0, 0) 100%);

    /* Heights per viewport */
    height: 40.75%;
    @media ${baseVariables.mediaQuery.md} {
      height: 38.87%;
    }
    @media ${baseVariables.mediaQuery.lg} {
      height: 45.55%;
    }
  }

  // Gradient for the bottom of the banner
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: ${({ $theme }) =>
      $theme === 'dark'
        ? 'linear-gradient(180deg, rgba(28,28,28,0) 2.68%, #1C1C1C 100%)'
        : 'linear-gradient(180deg, rgba(244,244,244,0) 2.68%, #F4F4F4 100%)'};

    /* Heights per viewport */
    height: 59.25%;
    @media ${baseVariables.mediaQuery.md} {
      height: 61.13%;
    }
    @media ${baseVariables.mediaQuery.lg} {
      height: 54.45%;
    }
  }
`;
